// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"carousel_wrapper__KUX2N","ctaLink":"carousel_ctaLink__DrIsy","icon-circle":"carousel_icon-circle__HS4dn"};